/* eslint-disable camelcase */
import { BaseTarget } from './BaseTarget';
import type { BaseAttributes } from './BaseTarget';

export interface AuthenticatedUser {
  id: number;
  country: string | null;
  created: number;
}

export interface UserTargetAttributes extends BaseAttributes {
  country_code?: string;
  user_created?: number;
}

class UserExperimentTarget extends BaseTarget {
  user: AuthenticatedUser;

  constructor(user: AuthenticatedUser) {
    super({ id: user.id });
    this.user = user;
  }

  // FIXME: Consider using a static method.
  // eslint-disable-next-line class-methods-use-this
  get prefix(): string {
    return 'user';
  }

  get attributes(): UserTargetAttributes {
    const attributes: UserTargetAttributes = {};

    if (this.user.country != null) {
      attributes.country_code = this.user.country;
    }

    if (this.user.created) {
      attributes.user_created = this.user.created;
    }

    return attributes;
  }

  validate(): boolean {
    return BaseTarget.prototype.validate.call(this);
  }
}

export { UserExperimentTarget as UserTarget };
